/**
 * Free Download Feature for Shopify
 * Replaces add-to-cart with email capture + Klaviyo subscription
 * Sends download link via Klaviyo email flow (not immediate download)
 */

(function () {
  'use strict';

  // ============================================================
  // CONFIGURATION — These are pulled from the section settings
  // injected via Liquid. Fall back to defaults if not set.
  // ============================================================
  const sectionEl = document.querySelector('.section-free-download');

  // Grab settings from the section's schema (rendered into data attributes or inline script)
  // We read them from the Liquid-rendered section settings via a hidden element
  const KLAVIYO_COMPANY_ID = getSettingFromSection('klaviyo_company_id') || 'YOUR_KLAVIYO_COMPANY_ID';
  const KLAVIYO_LIST_ID = getSettingFromSection('klaviyo_list_id') || 'YOUR_KLAVIYO_LIST_ID';
  const SUCCESS_MESSAGE = getSettingFromSection('success_message') || 'Check your email! Your download link is on its way.';

  // ============================================================
  // DOM Elements
  // ============================================================
  const emailInput = document.getElementById('downloadEmail');
  const downloadBtn = document.getElementById('download_button');
  const messageEl = document.getElementById('download_message');
  const variantDataEl = document.getElementById('free-download-variants');

  if (!emailInput || !downloadBtn) return;

  // ============================================================
  // Variant data (for products with multiple options/files)
  // ============================================================
  let variants = [];
  if (variantDataEl) {
    try {
      variants = JSON.parse(variantDataEl.textContent);
    } catch (e) {
      variants = [];
    }
  }

  // ============================================================
  // Variant Option Selector Logic
  // ============================================================
  const optionButtons = document.querySelectorAll('.free-download-option-btn');
  const selectedOptions = {};

  // Initialize selected options from the default/active buttons
  optionButtons.forEach(function (btn) {
    if (btn.classList.contains('active')) {
      selectedOptions[btn.dataset.optionIndex] = btn.dataset.value;
    }
  });

  optionButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var optionIndex = this.dataset.optionIndex;
      var value = this.dataset.value;

      // Update active state for this option group
      document.querySelectorAll('.free-download-option-btn[data-option-index="' + optionIndex + '"]')
        .forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');

      // Update the displayed selected value
      var labelSpan = document.getElementById('selected-option-' + optionIndex);
      if (labelSpan) labelSpan.textContent = value;

      // Store selection
      selectedOptions[optionIndex] = value;

      // Find matching variant and update download URL
      updateDownloadUrl();
    });
  });

  function updateDownloadUrl() {
    if (variants.length === 0) return;

    var selectedValues = Object.keys(selectedOptions)
      .sort()
      .map(function (key) { return selectedOptions[key]; });

    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      var match = true;
      for (var j = 0; j < selectedValues.length; j++) {
        if (variant.options[j] !== selectedValues[j]) {
          match = false;
          break;
        }
      }
      if (match) {
        // Update the download button's data-file attribute
        if (variant.metafield_download_url) {
          downloadBtn.setAttribute('data-file', variant.metafield_download_url);
        }
        // Update the product title for Klaviyo tracking
        downloadBtn.setAttribute('data-product-title',
          downloadBtn.getAttribute('data-product-title').split(' - ')[0] + ' - ' + variant.title
        );
        break;
      }
    }
  }

  // ============================================================
  // Image Gallery (thumbnail click to swap main image)
  // ============================================================
  var thumbnails = document.querySelectorAll('.free-download-thumbnail');
  var mainImage = document.querySelector('.free-download-main-image img');

  thumbnails.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbnails.forEach(function (t) { t.classList.remove('active'); });
      this.classList.add('active');
      if (mainImage) {
        mainImage.src = this.dataset.imageUrl;
        mainImage.alt = this.dataset.imageAlt || '';
      }
    });
  });

  // ============================================================
  // Download Button Click Handler
  // ============================================================
  downloadBtn.addEventListener('click', function (e) {
    e.preventDefault();

    var email = emailInput.value.trim();

    // Validate email
    if (!email || !isValidEmail(email)) {
      showMessage('Please enter a valid email address.', 'error');
      emailInput.focus();
      return;
    }

    var fileUrl = downloadBtn.getAttribute('data-file');
    var productTitle = downloadBtn.getAttribute('data-product-title');
    var productId = downloadBtn.getAttribute('data-product-id');

    if (!fileUrl) {
      showMessage('Download link not available. Please try again later.', 'error');
      return;
    }

    // Disable button while processing
    downloadBtn.disabled = true;
    downloadBtn.textContent = 'Sending...';

    // Subscribe to Klaviyo list AND fire a custom event for the flow trigger
    Promise.all([
      subscribeToKlaviyo(email, productTitle, productId, fileUrl),
      trackDownloadEvent(email, productTitle, productId, fileUrl)
    ])
      .then(function () {
        showMessage(SUCCESS_MESSAGE, 'success');
        downloadBtn.textContent = 'Sent!';
        emailInput.value = '';

        // Re-enable after 3 seconds
        setTimeout(function () {
          downloadBtn.disabled = false;
          downloadBtn.textContent = 'Download';
        }, 3000);
      })
      .catch(function (err) {
        console.error('Klaviyo error:', err);
        showMessage('Something went wrong. Please try again.', 'error');
        downloadBtn.disabled = false;
        downloadBtn.textContent = 'Download';
      });
  });

  // ============================================================
  // Klaviyo Subscribe API (Client-side, public key)
  // Uses Klaviyo's v3 Client Subscribe API
  // ============================================================
  function subscribeToKlaviyo(email, productTitle, productId, fileUrl) {
    var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID;

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Free Download - ' + productTitle,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: {
                  'Last Free Download': productTitle,
                  'Last Download URL': fileUrl,
                  'Last Download Product ID': productId
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: KLAVIYO_LIST_ID
            }
          }
        }
      }
    };

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      // Klaviyo returns 202 on success for subscriptions
      if (response.status !== 200 && response.status !== 202) {
        throw new Error('Klaviyo API responded with status ' + response.status);
      }
      return response;
    });
  }

  // ============================================================
  // Klaviyo Track Event API (Client-side)
  // Fires a custom "Requested Free Download" event every time
  // someone clicks Download — this triggers the flow reliably
  // even if the person is already on the list.
  // ============================================================
  function trackDownloadEvent(email, productTitle, productId, fileUrl) {
    var url = 'https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_COMPANY_ID;

    var payload = {
      data: {
        type: 'event',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email
              }
            }
          },
          metric: {
            data: {
              type: 'metric',
              attributes: {
                name: 'Requested Free Download'
              }
            }
          },
          properties: {
            'Download URL': fileUrl,
            'Product Name': productTitle,
            'Product ID': productId
          }
        }
      }
    };

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (response.status !== 200 && response.status !== 202) {
        throw new Error('Klaviyo Event API responded with status ' + response.status);
      }
      return response;
    });
  }

  // ============================================================
  // Helper Functions
  // ============================================================
  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function showMessage(text, type) {
    if (!messageEl) return;
    messageEl.textContent = text;
    messageEl.className = 'free-download-message free-download-message--' + type;
    messageEl.style.display = 'block';

    // Auto-hide after 5 seconds
    setTimeout(function () {
      messageEl.style.display = 'none';
    }, 5000);
  }

  function getSettingFromSection(settingKey) {
    // Section settings are rendered in the Liquid template.
    // We inject them as data attributes on the section element.
    // This function checks for a data attribute on the section wrapper.
    if (!sectionEl) return null;

    // Look for a script tag with section settings
    var settingsScript = sectionEl.querySelector('script[type="application/json"][data-section-settings]');
    if (settingsScript) {
      try {
        var settings = JSON.parse(settingsScript.textContent);
        return settings[settingKey] || null;
      } catch (e) {
        return null;
      }
    }
    return null;
  }

})();